// effects/personal-details.effects.ts
import { inject } from '@angular/core'
import { createEffect } from '@ngrx/effects'
import { Actions, ofType } from '@ngrx/effects'
import { FamilyService } from '../../services/family.service'
import { ToastrService } from 'ngx-toastr'
import { catchError, exhaustMap, map, of, switchMap } from 'rxjs'
import {
  createFamily,
  createFamilyFailure,
  createFamilySuccess,
  deleteFamily,
  deleteFamilyFailure,
  deleteFamilySuccess,
  loadFamilies,
  loadFamiliesFailure,
  loadFamiliesSuccess,
  updateFamily,
  updateFamilyFailure,
  updateFamilySuccess
} from './family.actions'

export const loadFamilies$ = createEffect(
  (actions$ = inject(Actions), familyService = inject(FamilyService)) =>
    actions$.pipe(
      ofType(loadFamilies),
      switchMap(
        (
          action // Use action.filter here
        ) =>
          familyService.getFamilies(action.params, action.page, action.limit).pipe(
            map(res =>
              loadFamiliesSuccess({
                families: res.families
              })
            ),
            catchError(error => of(loadFamiliesFailure({ error: error.message })))
          )
      )
    ),
  { functional: true }
)

export const createFamily$ = createEffect(
  (
    actions$ = inject(Actions),
    familyService = inject(FamilyService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(createFamily),
      exhaustMap(({ payload }) => {
        // 🔥 RETURN the inner observable here
        return familyService.createFamily(payload).pipe(
          map(created => {
            toastr.success('Created successfully!', 'Success')
            // store.dispatch(loadFamilies({ params: null, page: 1, limit: 10 }))
            // modalService.dismissAll()
            return createFamilySuccess({ family: created })
          }),
          catchError(error => {
            toastr.error('There was an error creating the record.', 'Error')
            return of(createFamilyFailure({ error }))
          })
        )
      })
    ),
  { functional: true, dispatch: true }
)

export const updateFamily$ = createEffect(
  (
    actions$ = inject(Actions),
    familyService = inject(FamilyService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(updateFamily), // 🔁 Listen for updateFamily action
      exhaustMap(({ id, payload }) => {
        return familyService.updateFamily(id, payload).pipe(
          map(updated => {
            toastr.success('Updated successfully!', 'Success')
            // store.dispatch(loadFamilies({ params: null, page: 1, limit: 10 }))
            // modalService.dismissAll()
            return updateFamilySuccess({ family: updated })
          }),
          catchError(error => {
            toastr.error('There was an error updating the record.', 'Error')
            return of(updateFamilyFailure({ error }))
          })
        )
      })
    ),
  { functional: true, dispatch: true }
)

export const deleteFamily$ = createEffect(
  (
    actions$ = inject(Actions),
    familyService = inject(FamilyService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(deleteFamily),
      exhaustMap(action =>
        familyService.deleteFamily(action.id).pipe(
          map(() => {
            toastr.success('Deleted successfully!')
            return deleteFamilySuccess({ id: action.id })
          }),
          catchError(error => {
            toastr.error('Failed to delete record: ' + error.message)
            return of(deleteFamilyFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

export const familyEffects = {
  createFamily$,
  loadFamilies$,
  updateFamily$,
  deleteFamily$
}
